import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/leads/touches/")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/touches", search, replace: true });
    },
});
